/*
 * File: WinscialError.tsx
 * Project: papa-bear
 * -----
 * Last Modified: 15 Nov 2021 4:44:30 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Button, Result, Space } from 'antd';
import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

interface WimsicalErrorProps {
  status: number;
  message: string;
}

export const WimsicalError: FC<WimsicalErrorProps> = ({ status, message }: WimsicalErrorProps) => {
  const navigate = useNavigate();

  const buttonJSX = (
    <Button onClick={(): void => navigate('/')} type="primary">
      Refresh Application
    </Button>
  );

  const title = (): string => {
    switch (status) {
      case 400:
        return 'Error';

      case 401:
        return 'Unauthorized';

      case 403:
        return 'Unauthorized';

      case 404:
        return 'Oops were unable to find what we were looking for!';

      case 500:
        return 'Internal Error';

      default:
        return 'Error';
    }
  };

  const statusConvert = (): undefined | 'error' | 'info' | 'warning' | 404 | 403 | 500 => {
    switch (status) {
      case 400:
        return 'error';

      case 403:
        return 403;

      case 404:
        return 404;

      case 500:
        return 500;

      default:
        return 'error';
    }
  };

  const messageJSX = (
    <Space direction="vertical">
      <div>Error: {message}</div>
      <div>Our team has been notified of the problem.</div>
    </Space>
  );

  return <Result status={statusConvert()} title={title()} subTitle={messageJSX} extra={buttonJSX} />;
};
